<div [formGroup]="group">
    <smvd-ui-text-input
        formControlName="value"
        [hasMarginDouble]="!question.tip"
        [hasMargin]="false"
        width="100%"
        [label]="question | questionTitle"
        [id]="question.id"
    >
    </smvd-ui-text-input>
    <p class="u-color-text u-margin-top-half u-margin-bottom-double" *ngIf="question.tip" [innerHtml]="question.tip | translateLabel"></p>
</div>
